import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import your components
import Home from "./pages/Home";
import AboutFullPage from "./pages/AboutFull";
import PrivacyAndPolicyPage from "./pages/PrivacyAndPolicy";
import FaqsFullPage from "./pages/FaqsFull";
import { LanguageTransitionProvider } from "./LanguageTransitionContext";
import NotFoundPage from "./pages/NotFound";
// import ContactFullPage from "./pages/ContactUsFull";

import "./i18n";
import ContactUsSubmittedPage from "./pages/ContactUsSubmitted";
import InternalErrorPage from "./pages/InternalError";
import ContactFullPage from "./pages/ContactUsFull";
import ForbiddenErrorPage from "./pages/ForbidenError";
import LandingPage from "./pages/landing-page/index";
import SuccessPage from "./pages/success/index";
import AnalyticsScripts from "./components/AnalyticsScripts";
import CustomHelmet from "./components/Helmet/Helmet";
import { useTranslation } from "react-i18next";
import DeepLinkHandler from "./pages/DeepLinkHandler";
import JobPage from "./pages/JobPage";
import SuccessJob from "./pages/SuccessJob";

function App() {
  const { t } = useTranslation();
  return (
    <LanguageTransitionProvider>
      <Router>
        <AnalyticsScripts />
        <CustomHelmet title={t("sak")} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about-sak" element={<AboutFullPage />} />
          <Route path="/privacy-policy" element={<PrivacyAndPolicyPage />} />
          <Route path="/privacy-policy-ar" element={<PrivacyAndPolicyPage />} />
          <Route path="/faqs" element={<FaqsFullPage />} />
          <Route
            path="/contact-us-submitted"
            element={<ContactUsSubmittedPage />}
          />
          <Route path="/something-went-wrong" element={<InternalErrorPage />} />
          <Route path="/not-allowed" element={<ForbiddenErrorPage />} />

          <Route path="/support" element={<ContactFullPage />} />
          <Route path="/contact-us" element={<ContactFullPage />} />
          <Route path="*" element={<NotFoundPage />} />
          <Route path="/projects/:id" element={<LandingPage />} />
          <Route path="/jobs/apply" element={<JobPage />} />
          <Route path="/jobs/success" element={<SuccessJob />} />
          
          <Route path="/thank-you" element={<SuccessPage />} />
          <Route path="/link" element={<DeepLinkHandler />} />
          <Route path="/link/*" element={<DeepLinkHandler />} />

        </Routes>
      </Router>
    </LanguageTransitionProvider>
  );
}

export default App;
